import Icon from '../assets'
import TextButton from '../../control-components/ui-components/TextButton'
import Phrase from '../../libs/translationsUtils/phrase'
import Attachment from './attachment'

const allowedFileTypes = [
  'zip',
  'pdf',
  'xml',
  'txt',
  'csv',
  'doc',
  'docx',
  'xls',
  'xlsx',
  'ppt',
  'pptx',
  'jpg',
  'jpeg',
  'gif',
  'png'
]

const AttachmentsList = ({ attachments = [], errors = [], onDelete, onDismissError }) => {
  if (!attachments.length && !errors.length) return null
  attachments.forEach((attachment) => {
    if (attachment.file_original_name === '') {
      attachment.file_original_name = attachment.source
      attachment.filename = attachment.source
    }
  })

  return <div class='content-attachments'>
    {
      errors.length
        ? <p class='content-attachments__error'>
          <span>
            {errors.map(({ filename, errorPhrase }) =>
              <span>{filename}: <Phrase m='Common' p={errorPhrase} count={{
                allowed_files_type: allowedFileTypes.join(', '),
                allowed_files_size: '5 Mb'
              }} /><br /></span>
            )}
          </span>
          <TextButton class='content-attachments__error-close' onClick={onDismissError}>
            <Icon width='18' height='18' icon='close' />
          </TextButton>
        </p>
        : null
    }
    {
      attachments.length
        ? <p class='content-attachments__counter'>
          <strong>{attachments.length} Attachments</strong>
        </p>
        : null
    }
    {
      attachments.length
        ? <ul class='content-attachments-list'>
          { attachments.map((attachment, index) =>
            <Attachment {...attachment} onDelete={() => onDelete(index)} />) }
        </ul>
        : null
    }
  </div>
}

export default AttachmentsList
